"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamepadAction = exports.GamepadButton = void 0;
var GamepadButton;
(function (GamepadButton) {
    GamepadButton["A"] = "A";
    GamepadButton["B"] = "B";
    GamepadButton["X"] = "X";
    GamepadButton["Y"] = "Y";
    GamepadButton["DpadUp"] = "DpadUp";
    GamepadButton["DpadDown"] = "DpadDown";
    GamepadButton["DpadLeft"] = "DpadLeft";
    GamepadButton["DpadRight"] = "DpadRight";
    GamepadButton["LeftBumper"] = "LeftBumper";
    GamepadButton["RightBumper"] = "RightBumper";
    GamepadButton["LeftStickButton"] = "LeftStickButton";
    GamepadButton["RightStickButton"] = "RightStickButton";
    GamepadButton["Center"] = "Center";
    GamepadButton["View"] = "View";
    GamepadButton["Menu"] = "Menu";
})(GamepadButton || (exports.GamepadButton = GamepadButton = {}));
var GamepadAction;
(function (GamepadAction) {
    GamepadAction["Down"] = "gamepadDown";
    GamepadAction["Up"] = "gamepadUp";
    GamepadAction["Long"] = "gamepadLong";
})(GamepadAction || (exports.GamepadAction = GamepadAction = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2FtZXBhZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9nYW1lcGFkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw0REFBNEQ7OztBQUk1RCxJQUFZLGFBZ0JYO0FBaEJELFdBQVksYUFBYTtJQUNyQix3QkFBTyxDQUFBO0lBQ1Asd0JBQU8sQ0FBQTtJQUNQLHdCQUFPLENBQUE7SUFDUCx3QkFBTyxDQUFBO0lBQ1Asa0NBQWlCLENBQUE7SUFDakIsc0NBQXFCLENBQUE7SUFDckIsc0NBQXFCLENBQUE7SUFDckIsd0NBQXVCLENBQUE7SUFDdkIsMENBQXlCLENBQUE7SUFDekIsNENBQTJCLENBQUE7SUFDM0Isb0RBQW1DLENBQUE7SUFDbkMsc0RBQXFDLENBQUE7SUFDckMsa0NBQWlCLENBQUE7SUFDakIsOEJBQWEsQ0FBQTtJQUNiLDhCQUFhLENBQUE7QUFDakIsQ0FBQyxFQWhCVyxhQUFhLDZCQUFiLGFBQWEsUUFnQnhCO0FBUUQsSUFBWSxhQUlYO0FBSkQsV0FBWSxhQUFhO0lBQ3JCLHFDQUFvQixDQUFBO0lBQ3BCLGlDQUFnQixDQUFBO0lBQ2hCLHFDQUFvQixDQUFBO0FBQ3hCLENBQUMsRUFKVyxhQUFhLDZCQUFiLGFBQWEsUUFJeEIifQ==